import React, { Component } from "react";
import { Row, Col, Button, Image } from "react-bootstrap";
import { FaDownload, FaSpinner } from "react-icons/fa";
import Chart from "chart.js";
import Encryption from "../utils/Encryption";
import { sskowk, apiURL } from "../utils/constants";
import logo from "../Resources/images/criteriaLogo_wordmark.png";
import { getChartConfig } from "./helpers";

export default class WorkplaceInsights extends Component {
  constructor() {
    super();
    this.state = {
      html: "",
      data: null,
      name: "",
      downloadClicked: false
    };
  }

  /* ---------- React LifeCycle Methods ---------- */

  componentDidMount() {
    document.title = `Workplace Insights - Criteria Corp`;
    const apiUrl = `${apiURL.replace("oda", "v1")}/insightReportsLink/${
      this.props.param1
    }/${this.props.param2}/html`;
    // eslint-disable-next-line no-unused-vars
    const getWorkplaceInsights = (async () => {
      try {
        const response = await fetch(apiUrl);
        const responseData = await response.json();

        const encryption = new Encryption();
        const decryptedData = responseData.data
          ? JSON.parse(encryption.decrypt(responseData.data, sskowk))
          : null;

        const report = atob(decryptedData.report);
        this.setState({
          html: report,
          data: decryptedData.scores,
          name: decryptedData.name
        });
      } catch (error) {
        console.log("error: ", error);
      }
    })();
  }

  handleDownload = () => {
    this.setState({ downloadClicked: true });
    const apiUrl = `${apiURL.replace("oda", "v1")}/insightReportsLink/${
      this.props.param1
    }/${this.props.param2}/pdf`;

    // eslint-disable-next-line no-unused-vars
    const getWorkplaceInsights = (async () => {
      try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        const encryption = new Encryption();
        const decryptedData = data.data
          ? JSON.parse(encryption.decrypt(data.data, sskowk))
          : null;

        if (window.navigator.msSaveOrOpenBlob) {
          const sliceSize = 1024;
          const byteCharacters = atob(decryptedData.report.replace(/[Â]/g, ""));
          const bytesLength = byteCharacters.length;
          const slicesCount = Math.ceil(bytesLength / sliceSize);
          const byteArrays = new Array(slicesCount);
          // eslint-disable-next-line no-plusplus
          for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            const begin = sliceIndex * sliceSize;
            const end = Math.min(begin + sliceSize, bytesLength);

            const bytes = new Array(end - begin);
            // eslint-disable-next-line no-plusplus
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
              bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
          }
          const blob = new Blob(byteArrays, { type: "application/pdf" });
          window.navigator.msSaveOrOpenBlob(blob, "WorkplaceInsights.pdf");
        } else {
          const dlnk = document.getElementById("testReportDwnldLnk");

          const dlnkDownloadBefore = dlnk.download;
          dlnk.download += `-Workplace-Insights.pdf`;
          dlnk.href = `data:application/pdf;base64,${decryptedData.report}`;
          dlnk.click();
          dlnk.download = dlnkDownloadBefore;
        }
        this.setState({ downloadClicked: false });
      } catch (error) {
        console.log("error: ", error);
      }
    })();
  };

  render() {
    if (this.state.data) {
      let workplaceInsightsScores = this.state.data;

      // We need to determine if the WIR is for Illustrait or other tests since the
      // graph labels and scores will be different.
      // EPP WIR reports should have data length as 10 (10 traits)
      // Illustrait WIR reports should have data length as 8 (8 traits)
      const illustraitWIR = this.state.data.length === 8;
      if (!illustraitWIR) {
        workplaceInsightsScores = this.state.data.map(item => item + 25);
      }

      Chart.defaults.global.defaultFontColor = "#001f4e";
      setTimeout(() => {
        const ctx = document.getElementById("myChart")
          ? document.getElementById("myChart").getContext("2d")
          : null;

        if (ctx) {
          // eslint-disable-next-line no-unused-vars
          const myRadarChart = new Chart(
            ctx,
            getChartConfig(workplaceInsightsScores, illustraitWIR, true)
          );
        }
      }, 100);
    }

    return (
      <>
        <Row
          className="pb-3 mb-3"
          style={{
            position: "sticky",
            top: 0,
            boxShadow: "0 2px 2px #CCC",
            backgroundColor: "#FFF",
            zIndex: 1020,
            marginTop: "-16px",
            paddingTop: "16px"
          }}
        >
          <Col>
            <Image
              src={logo}
              alt="Criteria Corp. On Demand Assessment"
              fluid={true}
            />
          </Col>
          <Col className="text-right">
            <Button
              variant="outline-primary"
              onClick={this.handleDownload}
              disabled={this.state.downloadClicked}
            >
              {this.state.downloadClicked ? <FaSpinner /> : <FaDownload />}{" "}
              {this.state.downloadClicked ? "Please Wait..." : "Download PDF"}
            </Button>
          </Col>
        </Row>
        <div dangerouslySetInnerHTML={{ __html: this.state.html }} />
        <div className="text-center" style={{ color: "#AAA" }}>
          &copy; {new Date().getFullYear()} Criteria Corporation. All Rights
          Reserved &bull; www.criteriacorp.com
        </div>
        <a
          id="testReportDwnldLnk"
          download={this.state.name}
          style={{ display: "none" }}
          href
        >
          dwnld
        </a>
      </>
    );
  }
}
